import { pdf } from "@react-pdf/renderer";
import moment from "moment";
import React from "react";
import TemplatePDF from "../components/Templates/TemplatePDF";

const sanitizeFilenamePart = (value) =>
  String(value || "informe")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9_-]+/g, "_")
    .replace(/^_+|_+$/g, "");

const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () =>
      resolve(String(reader.result).replace(/^data:.*;base64,/, ""));
    reader.onerror = () =>
      reject(new Error("No se pudo generar el informe técnico"));
    reader.readAsDataURL(blob);
  });

export const getTemplateForVisit = (templates, visitId) => {
  if (!templates || !visitId) return null;
  return (
    Object.values(templates).find(
      (template) => String(template?.visit || "") === String(visitId),
    ) || null
  );
};

export const resolveSharedSignature = (...sources) =>
  sources.find(
    (signature) =>
      typeof signature === "string" &&
      /^data:image\/(png|jpeg|jpg);base64,/.test(signature),
  ) || null;

export const withSharedSignature = (template, visit) => {
  if (!template && !visit) return template;
  return {
    ...(template || {}),
    signature: resolveSharedSignature(visit?.signature, template?.signature),
  };
};

export const buildTemplatePdfAttachment = async (template, visit) => {
  if (!template) return null;

  const date = template.date ? moment(template.date) : moment();
  const filename = `Informe_tecnico_${sanitizeFilenamePart(
    template.laundry,
  )}_${date.format("DDMMYYYY")}.pdf`;
  const document = React.createElement(TemplatePDF, {
    data: {
      ...template,
      signature: resolveSharedSignature(visit?.signature, template?.signature),
      date: date.toDate(),
    },
    fileName: filename,
  });
  const blob = await pdf(document).toBlob();

  return {
    filename,
    content: await blobToBase64(blob),
  };
};
